import { FF } from 'modules/feature-flags/featureFlags.generated';
import { useSplitFlag } from 'modules/feature-flags/useSplitFlag';
import { useMemo } from 'react';
import { CacheStrategy } from 'modules/viewer/PixelCacheStategy';
import { useFeatureFlagEnabled } from 'modules/feature-flags';

export const useViewerDownloadingFlags = (): {
  viewerCacheStrategy: CacheStrategy;
  viewerCacheRegulation: boolean;
  loadingViewerDownloadingFlags: boolean;
} => {
  const [viewerCacheStrategy, loadingViewerCacheStrategy] = useSplitFlag<CacheStrategy>(
    FF.VIEWER_CACHE_STRATEGY
  );
  const [viewerCacheRegulation, loadingViewerCacheRegulation] = useFeatureFlagEnabled(
    FF.REGULATED_PIXEL_CACHE
  );

  return useMemo(
    () => ({
      viewerCacheStrategy,
      viewerCacheRegulation,
      loadingViewerDownloadingFlags: loadingViewerCacheStrategy || loadingViewerCacheRegulation,
    }),
    [
      viewerCacheStrategy,
      loadingViewerCacheStrategy,
      viewerCacheRegulation,
      loadingViewerCacheRegulation,
    ]
  );
};
